/**
 * Names in the designer's lists end in numbers more often than not ("Translate v2", "ai10",
 * "Welcome 2"), and a plain `localeCompare` reads those digit by digit: ai1, ai10, ai11, ai2.
 * `numeric` makes an "A–Z" label mean what it promises.
 *
 * One collator, reused across every list — constructing one per comparison is the expensive way
 * to sort.
 */
export const NAME_COLLATOR: Intl.Collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base"
});
